import {AbstractControl} from '@angular/forms';

export function phoneValidator(control: AbstractControl) {
  const phoneRe = /^[2-9][0-8]\d{1}[2-9](?![1]{2})\d{2}\d{4}$/;
  const internationalPhoneRe = /^\+(?:[0-9] ?){6,14}[0-9]$/;
  if (control.value !== null && control.value !== undefined && control.value.length > 0) {
    const digits = control.value.replace(/\D/g, '');
    if (!phoneRe.test(digits) && !internationalPhoneRe.test(digits)) {
      return {
        invalidPhone: true
      };
    }
  }

  return null;
}

export function ValidateEmail(control: AbstractControl) {
  if (!control.value) {
    return null;
  }

  const valid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(control.value);

  if (valid) {
    return null;
  }

  return {invalidEmail: true};
}

export function zipValidator(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = /^\d{5}(?:[-\s]\d{4})?$/;
  if (control.value.length > 0 && !regex.test(control.value)) {
    return {
      invalidZip: true
    };
  }
  return null;
}
